<mat-form-field class="w-full" appearance="outline" [floatLabel]="floatLabel">
  <mat-label i18n="@@loan_status">Loan Status</mat-label>
  <mat-select
    (selectionChange)="statusChange($event.value)"
    [formControl]="ctrl"
  >
    <mat-option [value]="0">All</mat-option>
    <mat-option value="RUNNING">Running</mat-option>
    <mat-option value="CLOSED">Closed</mat-option>
    <mat-option value="DEFAULT">Defaulted</mat-option>
  </mat-select>
</mat-form-field>
